import { render, staticRenderFns } from "./PackageRegister.vue?vue&type=template&id=ba238ada"
import script from "./PackageRegister.vue?vue&type=script&lang=js"
export * from "./PackageRegister.vue?vue&type=script&lang=js"
import style0 from "./PackageRegister.vue?vue&type=style&index=0&id=ba238ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports